import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {CallStudioApiService} from '../settings/call-flow-configurations/call-studio/call-studio-api.service';
import {firstValueFrom, forkJoin, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class DynamicBlacklistApiService {

  readonly dynamicBlackListUrl: string = 'blacklist';

  constructor( private http: HttpClient,
               private callSetupRuleApiService: CallStudioApiService){
  }

  public getBlacklist(): Observable<any> {
    return this.http.get(this.dynamicBlackListUrl);
  }

  public getBlacklistForTable(): Observable<any> {
    return forkJoin([this.http.get(this.dynamicBlackListUrl), this.callSetupRuleApiService.getCallsItems()])
      .pipe(map((result: any) => {
        result[0].forEach(b => {
          b.policyStudioName = _.find(result[1], {id: b.policyId}).name;
          b.direction = _.find(result[1], {id: b.policyId}).sourceOrDestinationNumber;
        });
        return result[0];
      }));
  }

  public unblockNumber(blacklistNumber: any): Promise<any> {

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: blacklistNumber
    };

    return firstValueFrom(this.http.delete(this.dynamicBlackListUrl,  options));
  }

  public unblockAllNumbers(): Promise<any> {
    return firstValueFrom(this.http.delete(this.dynamicBlackListUrl));
  }


}
